import script from "./stats.vue?vue&type=script&setup=true&lang=js"
export * from "./stats.vue?vue&type=script&setup=true&lang=js"

import "./stats.vue?vue&type=style&index=0&id=1fec0f64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fec0f64"]])

export default __exports__